import type { ReportHandler } from "web-vitals";

export const createWebVitalsMulticaster = (
  ...handlers: ReportHandler[]
): ReportHandler => {
  return (metric) => {
    for (const handler of handlers) {
      handler(metric);
    }
  };
};

export function reportWebVitals(onPerfEntry: ReportHandler) {
  import("web-vitals").then(({ onCLS, onFID, onFCP, onLCP, onTTFB, onINP }) => {
    onCLS(onPerfEntry);
    onFID(onPerfEntry);
    onFCP(onPerfEntry);
    onLCP(onPerfEntry);
    onTTFB(onPerfEntry);
    onINP(onPerfEntry);
  });
}
